import { render } from "./SectionLinks.vue?vue&type=template&id=507d24c0"
import script from "./SectionLinks.vue?vue&type=script&lang=js"
export * from "./SectionLinks.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__